import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import BrandHeader from "../components/BrandHeader";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function CoachLogin() {
  const startLogin = () => {
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-brand-base">
      <BrandHeader small />
      <main className="px-6 md:px-12 lg:px-16 pb-24 max-w-2xl mx-auto pt-12 text-center">
        <div className="inline-flex items-center justify-center h-14 w-14 rounded-full bg-[#FBF5EC] border border-brand-border mx-auto">
          <Lock className="text-brand-primary" strokeWidth={1.4} size={24} />
        </div>
        <h1 className="font-serif text-4xl sm:text-5xl text-brand-ink mt-6">Coach sign in</h1>
        <p className="mt-4 text-brand-ink-muted max-w-lg mx-auto">
          Access is restricted to the HER Aligned coach account. Sign in with your Google email
          to view client roadmaps.
        </p>
        <button
          onClick={startLogin}
          className="btn-primary mt-10 inline-flex items-center gap-2"
          data-testid="coach-google-signin-btn"
        >
          Sign in with Google
        </button>
        <div className="mt-12">
          <Link to="/" className="btn-ghost text-sm" data-testid="coach-login-back-link">
            Back to client app
          </Link>
        </div>
      </main>
    </div>
  );
}
